import { buttonClasses, SxProps } from '@mui/material'

interface CurrencyModalStyles {
  container: SxProps
  list: SxProps
  currencyButton: SxProps
  currencyButtonActive: SxProps
  currencyIcon: SxProps
  actionsWrapper: SxProps
  cancelButton: SxProps
  confirmButton: SxProps
}

// Mirrors the main site's currency modal (see components/Inputs/CurrencyAndLocation).
export const currencyModalStyles: CurrencyModalStyles = {
  container: {
    width: {
      md: 400,
      xs: '100%',
    },
    mb: { xs: 4 },
  },
  list: {
    maxHeight: { md: 450 },
    overflowY: { md: 'auto' },
  },
  currencyButton: {
    display: 'flex',
    border: '1px solid',
    borderColor: 'utils.gray300',
  },
  currencyButtonActive: {
    [`&.${buttonClasses.colorSecondary}`]: {
      borderColor: 'background.dark',
    },
  },
  currencyIcon: {
    width: 18,
  },
  actionsWrapper: {
    gap: 1.5,
    flexDirection: { xs: 'column-reverse', md: 'row-reverse' },
  },
  cancelButton: {
    minWidth: 'auto',
    py: 1,
    border: '1px solid',
    borderColor: 'utils.gray300',
  },
  confirmButton: {
    minWidth: 'auto',
    py: 1,
    boxShadow: 'none',
  },
}
